import InnerPageBAds from './InnerPageBAds';
export default InnerPageBAds;
